<template>
  <div
    class="sj_drawer"
    :style="eleStyle"
    :class="[direction, { dragging, hidden: collapsed }]"
  >
    <div class="drawer_content">
      <slot> </slot>
    </div>
    <div
      :class="['resizeable', direction]"
      @mousedown="handleMouseDown"
      v-if="!collapsed"
    ></div>
    <ToggleBtn
      :direction="direction"
      :value="!collapsed"
      @input="collapsed = !$event"
    />
  </div>
</template>
<script>
import ToggleBtn from "./ToggleBtn";
export default {
  name: "SjDrawer",
  components: { ToggleBtn },
  props: {
    initValue: Number,
    defaultCollapsed: {
      type: Boolean,
      default: false
    },
    direction: {
      type: String,
      default: "left" // left/right/bottom/top
    }
  },
  data() {
    return {
      value: this.initValue,
      mousePos: 0,
      collapsed: this.defaultCollapsed,
      dragging: false,
      startValue: 0
    };
  },
  computed: {
    eleStyle() {
      const size = `${this.value}px`;
      if (this.generalDirection === "horizontal") {
        return {
          width: size
        };
      } else {
        return {
          height: size
        };
      }
    },
    generalDirection() {
      if (this.direction === "left" || this.direction === "right")
        return "horizontal";
      else return "vertical";
    }
  },
  methods: {
    resize(e) {
      let delta;
      if (this.generalDirection === "horizontal") {
        delta = (this.mousePos - e.x) * (this.direction === "left" ? -1 : 1);
        this.mousePos = e.x;
      } else {
        delta = (this.mousePos - e.y) * (this.direction === "bottom" ? 1 : -1);
        this.mousePos = e.y;
      }
      this.value = this.value + delta;
    },

    handleMouseDown(event) {
      event.preventDefault();
      if (this.generalDirection === "horizontal") {
        this.mousePos = event.x;
      } else {
        this.mousePos = event.y;
      }
      this.dragging = true;
      this.startValue = this.value;
      document.addEventListener("mousemove", this.resize, false);
    },

    unBindMouseMoveEvent() {
      this.dragging = false;
      document.removeEventListener("mousemove", this.resize, false);
    }
  },
  mounted() {
    document.addEventListener("mouseup", this.unBindMouseMoveEvent, false);
  },
  beforeDestroy() {
    document.removeEventListener("mouseup", this.unBindMouseMoveEvent, false);
  },
  watch: {
    value: {
      handler(value) {
        if (value <= 0) {
          this.collapsed = true;
          this.value = this.startValue;
        } else {
          // this.collapsed = false;
        }
      }
    }
  }
};
</script>
<style lang="less" scoped>
.sj_drawer {
  position: relative;
  &:not(.dragging) {
    transition: 0.5s;
  }

  &.left,
  &.right {
    &.hidden {
      width: 0 !important;
    }
  }

  &.top,
  &.bottom {
    &.hidden {
      height: 0 !important;
    }
  }
  .resizeable {
    display: block;
    position: absolute;
    z-index: 0;
    touch-action: none;
    user-select: none;
    &.left,
    &.right {
      top: 0;
      height: 100%;
      width: 12px;
    }
    &.left {
      cursor: e-resize;
      right: -6px;
    }
    &.right {
      cursor: w-resize;
      left: -6px;
    }
    &.top,
    &.bottom {
      left: 0;
      width: 100%;
      height: 12px;
    }
    &.bottom {
      cursor: n-resize;
      top: -6px;
    }
    &.top {
      cursor: s-resize;
      bottom: -6px;
    }
  }
  .drawer_content {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
}
</style>
